import AddIdentifierForm from './add-identifier-form';

export default AddIdentifierForm;
